// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import announcement03Icon from "@/assets/icons/announcement-03.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Announcement03IconProps = Omit<IconProps, "name">;

export function Announcement03Icon(props: Announcement03IconProps): React.ReactNode {
  return <Icon name={announcement03Icon} {...props} />;
}
